export default __webpack_public_path__ + "static/Mejoberry-d734a936b040cc8a47485f417e0c10e8.png";